import React, { useEffect, useState, useCallback } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import { useSelector } from "react-redux";
import useSound from "use-sound";
import ErrorSoundFile from "../../../../Sound/Error.wav";

const fmt = require("indian-number-format");
const backend = await new Backend().init();

export default function TopCard({ user_id }) {
  const total = useSelector((state) => state.totalmodal);
  const admin_pf = useSelector((state) => state.totalmodaladmin_pf);

  const [playError] = useSound(ErrorSoundFile);

  const [loading, setLoading] = useState(false);
  const [profitLoss, setProfitLoss] = useState(0);

  const loadProfitLoss = useCallback(async () => {
    if (!user_id) return;

    setLoading(true);

    try {
      const baseData = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id : user_id
      };

      const data = baseData;

      let res = await backend.profit_loss(data);

      if (res?.error === "False") {
        setProfitLoss(+res.profit_loss || 0);
      } else {
        if (res?.logout === 1) {
          window.LogOut?.();
        } else {
          playError();
          toast.error(res?.message || "Failed to load P/L data");
        }
      }
    } catch (err) {
      playError();
      toast.error("Error loading P/L data");
      console.error("TopCard Load Error:", err);
    } finally {
      setLoading(false);
    }
  }, [user_id, playError]);

  useEffect(() => {
    loadProfitLoss();
  }, [loadProfitLoss]);

  const netAdminPf = admin_pf < 0 ? -admin_pf : admin_pf;

  const cardStyle = {
    minWidth: "120px",
    padding: "6px 12px",
    borderRadius: "8px",
    background: "var(--background)",
    border: "2px solid var(--hover)",
    color: "var(--text)",
    display: "flex",
    flexDirection: "column",
  };

  const labelStyle = {
    fontSize: "0.7rem",
    opacity: 0.7,
    fontWeight: 500,
  };

  const valueStyle = {
    fontSize: "1rem",
    fontWeight: 700,
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        padding: "10px 20px",
        background: "var(--background)",
        color: "var(--text)",
        borderBottom: "1px solid var(--hover)",
        alignItems: "center",
      }}
    >
      {/* LEFT SIDE CARDS */}
      <div style={cardStyle}>
        <span style={labelStyle}>TOTAL P/L</span>
        <span
          style={{
            ...valueStyle,
            color: total >= 0 ? "var(--buy)" : "var(--sell)",
          }}
        >
          {fmt.format(total.toFixed(0))}
        </span>
      </div>

      {/** ADMIN SELF P/L */}
      <div style={cardStyle}>
        <span style={labelStyle}>SELF PROFIT LOSS</span>
        <span
          style={{
            ...valueStyle,
            color: admin_pf >= 0 ? "var(--sell)" : "var(--buy)",
          }}
        >
          {fmt.format(netAdminPf.toFixed(0))}
        </span>
      </div>

      <div style={cardStyle}>
        <span style={labelStyle}>BOOKED</span>
        <span
          style={{
            ...valueStyle,
            color: profitLoss >= 0 ? "var(--buy)" : "var(--sell)",
          }}
        >
          {fmt.format(profitLoss.toFixed(0))}
        </span>
      </div>
    </div>
  );
}
